const PREFIX = "[PhotoSession]";

let seq = 0;

function isEnabled(): boolean {
  if (import.meta.env.DEV) return true;
  try {
    return localStorage.getItem("photoSessionDebug") === "1";
  } catch {
    return false;
  }
}

export function psLog(
  event: string,
  data?: Record<string, unknown>,
): void {
  if (!isEnabled()) return;
  const id = ++seq;
  const ts = new Date().toISOString().slice(11, 23);
  if (data && Object.keys(data).length > 0) {
    console.log(`${PREFIX} #${id} ${ts} ${event}`, data);
  } else {
    console.log(`${PREFIX} #${id} ${ts} ${event}`);
  }
}

export function psWarn(
  event: string,
  data?: Record<string, unknown>,
): void {
  if (!isEnabled()) return;
  const id = ++seq;
  const ts = new Date().toISOString().slice(11, 23);
  if (data && Object.keys(data).length > 0) {
    console.warn(`${PREFIX} #${id} ${ts} ${event}`, data);
  } else {
    console.warn(`${PREFIX} #${id} ${ts} ${event}`);
  }
}
